@if (showLoader()) {
    @if (type === 'spinner') {
        <div class="spinner"></div>
    }

    @if (type === 'overlay' || type === 'overlayAndSpinner' || type === 'overlaidSpinner') {
        <div class="overlay" [ngClass]="{ noBg: type === 'overlaidSpinner', light: overlayType === 'light' }">
            @if (type === 'overlayAndSpinner' || type === 'overlaidSpinner') {
                <div class="spinner"></div>
            }
        </div>
    }
}
